require("-!/data/jenkins/workspace/CD-PROD/feedback-ui/node_modules/extract-text-webpack-plugin/loader.js?omit=1&remove=true!style-loader!css-loader!less-loader!/data/jenkins/workspace/CD-PROD/feedback-ui/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/data/jenkins/workspace/CD-PROD/feedback-ui/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 1126
// module chunks = 0